<template>

    <v-page fixed>

        <v-page-header title="Rewards" icon="fas fa-gift" />

        <v-page-body>
            <v-section-share :affiliate="affiliate" />
            <v-section-stats v-if="affiliate" :affiliate="affiliate" />
            <v-section-update v-if="affiliate" :affiliate="affiliate" />
            <v-section-create v-if="!affiliate" @saved="affiliate = $event" />
        </v-page-body>

    </v-page>

</template>

<script>

import SectionCreate from './components/SectionCreate';
import SectionUpdate from './components/SectionUpdate';
import SectionShare from './components/SectionShare';
import SectionStats from './components/SectionStats';
import UserApi from '@api/UserApi';

export default {

    components: {
        'v-section-create': SectionCreate,
        'v-section-update': SectionUpdate,
        'v-section-share': SectionShare,
        'v-section-stats': SectionStats,
    },

    data() {
        return {
            starting: true,
            affiliate: null,
        }
    },

    mounted() {
        this.getAffiliate();
    },

    methods: {

        getAffiliate() {
            this.$store.commit('loading', true);
            UserApi.getAffiliate()
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.affiliate = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

    }

}

</script>